import gql from 'graphql-tag';
import moveIqAddressDetail from './moveiq-address-detail';

const NAME = 'moveIqMove';
const FRAGMENT = `fragment ${NAME} on MoveIqMove {
  homeSize
  id
  moveDate
  moveId
  fromAddressDetails {
    ...${moveIqAddressDetail.name}
  },
  toAddressDetails {
    ...${moveIqAddressDetail.name}
  }
}
${moveIqAddressDetail.fragment}
`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
